import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { CardTaps } from "../../../theme/Component/CardTaps";
import { ResumeImp } from "../../config/InfoTramiteComponents/ResumeImp/ResumeImp";
import { NotesImp } from "../../config/InfoTramiteComponents/NotesImp/NotesImp";
import { CardTramitesHistory } from "../../config/InfoTramiteComponents/HistoryImp/CardTramitesHistory";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";
import { FileService } from "../../../../core/services/FileService";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { toast } from "react-toastify";

interface Props {
    idProcedureIMP: number;
}

export const BPMVerifyDocument = ({ idProcedureIMP }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_Inbox);
    const fileService = new FileService();
    const [obs, setObs] = useState<string>("")

    const [listDoc, setListDoc] = useState([])
    const [doc, setDoc] = useState<any>({});
    const [modalAction, setModalAction] = useState<any>({ name: 'Gestión Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Visor de Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getProcedureActionForVerify(_single.getAccountID(), idProcedureIMP).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { console.log(err) })
    }

    const head = [
        { title: 'Codigo', property: 'AlphaCode', visible: true },
        { title: 'Procedimiento', property: 'ProcedureName', visible: true },
        { title: 'Paso', property: 'ProcedureActionName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Fecha de Asignacion', property: 'AssignmentDate', visible: true },
    ]

    useEffect(() => {
        if (bean.IDAction) {
            setListDoc(bean.Media ? JSON.parse(bean.Media) : [])
            setModalAction({ ...modalAction, "view": true, "name": `Actividad - ${bean.Name}` });
        }
    }, [bean])

    const vierDocument = (item: any) => {
        setDoc(item);
        console.log(item)
        setModal({ ...modal, "view": true });
    }

    const acceptDoc = () => {
        instance.verifyProcedureAction(bean.IDAction, obs).then(
            (resp) => {
                setObs("")
                getLista();
                setModalAction({ ...modalAction, "view": false })
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("No se pudo realizar la acción");
            }
        )
    }

    const declineDoc = () => {
        instance.declineProcedureAction(bean.IDAction, obs).then(
            (resp) => {
                setObs("")
                getLista();
                setModalAction({ ...modalAction, "view": false });
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("No se pudo realizar la acción");
            }
        )

    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </div>

            <div className="col-md-12">
                <Modal modal={modalAction} updateModal={setModalAction} >
                    <div className="row">
                        {/* <PrintJson json={bean} /> */}
                        <div className="col-md-12">
                            {listDoc.length === 0 ? (
                                <h4>No hay documentos anexos</h4>
                            ) :
                                <div className="list-group">
                                    {listDoc.map((item: any, index: number) => {
                                        return (
                                            <button onClick={() => { vierDocument(item) }} key={index} type="button" className="list-group-item list-group-item-action" aria-current="true">
                                                <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                                {item.UploadName} - {item.Name}
                                            </button>
                                        )
                                    })}
                                </div>
                            }
                        </div>
                        <div className="col-md-12 mt-4">
                            <label >Justificación</label>
                            <textarea rows={5} value={obs} onChange={(e) => { setObs(e.target.value) }} className="form-control" />
                        </div>
                        <div className="col-md-12 mt-4">
                            <div className="row d-flex justify-content-around">
                                <div className="col-md-6">
                                    <BasicButton eventClick={() => {
                                        if (obs.length > 15) {
                                            acceptDoc();
                                        } else {
                                            toast.error("La justifiación debe tener minimo 15 caracteres");
                                        }
                                    }} icon="ri-check-line" children={"Acpetar"} />
                                </div>
                                <div className="col-md-6 d-flex justify-content-end">
                                    <BasicButton eventClick={() => {
                                        if (obs.length > 15) {
                                            declineDoc();
                                        } else {
                                            toast.error("La justifiación debe tener minimo 15 caracteres");
                                        }
                                    }} icon="ri-close-line" children={"Rechazar"} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={modal} updateModal={setModal}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <VisorAnyDocument url={fileService.getUrlFile(doc.MediaContext, doc.Media)} type={doc?.TypeName} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}